import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  PostWidgetAnalysisConfigPayload,
  PostWidgetDefaultConfigPayload
} from "@/types/widget";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const postWidgetAnalysisConfig = async (
  body: PostWidgetAnalysisConfigPayload
) => {
  const { id, ...payload } = body;

  try {
    const { data } = await axiosInstance.post(
      `/v1/datasets/${id}/analytics`,
      payload
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postWidgetDefaultConfig = async (
  body: PostWidgetDefaultConfigPayload
) => {
  const { id, grid_config, group_by } = body;

  try {
    const { data } = await axiosInstance.post(
      `/v1/datasets/${id}/default-widgets`,
      // only include grid_config and group_by if they are provided.
      // it for H3 Dataset which requires grid_config to determine the default widget
      {
        ...(grid_config?.aggregation_type && { grid_config }),
        ...(group_by && { group_by })
      }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
